import { Component, OnInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ConnectRestService } from '../services/connect-rest.service';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { AppComponent } from '../app.component';
import { TransactionConstants, EnglishTranslation, MalayTranslation } from '../app.constants';
import { AppUtilityService } from '../common/app-utility.service';
import { CloneVisitor } from '@angular/compiler/src/i18n/i18n_ast';


declare var $: any;

@Component({
    selector: 'app-about-your-transaction',
    templateUrl: './about-your-transaction.component.html',
    styleUrls: ['./about-your-transaction.component.scss']
})
export class AboutYourTransactionComponent implements OnInit {

    transactionDetails: FormGroup;
    supplier: FormArray;
    customer: FormArray;
    custSuppLoc: FormArray;
    goodsLoc: FormArray;
    currControl: FormArray;
    // supplierHasCrimea: boolean = false;
    // customerHasCrimea: boolean = false;
    hasCrimea: boolean = false;
    sel_custSuppLoc: FormArray;
    sel_goodsLoc: FormArray;


    isEditMode: boolean = false;
    refETDL: any;
    refNTDL: any;
    refPADL: any;
    refCCDL: any;
    refET: any;
    refDWC: any;
    check_crimea: boolean = false;
    addcustSuppLocBtn = 1;
    addgoodsLocBtn = 1;
    crimeaError: boolean;
    dealWithCrimeaFlag: boolean;
    textContent: any;
    langTranslation: any;

    constructor(public router: Router,
        private formBuilder: FormBuilder,
        private connectRestService: ConnectRestService,
        private activatedRoute: ActivatedRoute,
        public appComp: AppComponent,
        private AppUtility: AppUtilityService) { }




    // (Begin) Added by CJT / Code by Sonny 09Jul2020
    //change request for SIR 9 and 14 --- start
    // find word 'onPaste="return false" onDrop="return false" onDrag="return false"' for relevant change in HTML
    @HostListener('document:keydown', ['$event'])
    onKeyPress(elemValue) {

        return this.AppUtility.characterValidation(elemValue.key)

    }
    // (End) CJT / Sonny 09Jul2020

    ngOnInit() {
        this.langTranslation = sessionStorage.getItem("language");
        this.textContent = this.langTranslation == 'en-us' || this.langTranslation == undefined ? EnglishTranslation.AboutYourTransactionScreen : MalayTranslation.AboutYourTransactionScreen;
        this.transactionDetails = this.formBuilder.group({
            accountUsage: ['', Validators.required],
            accountUsageOthers: [''],
            activeIncome: [''],
            salesOrigin: ['', Validators.required],
            goodsLocation: [''],
            custSuppLocation: [''],
            transactionCount: ['', Validators.required],
            transactionAmount: ['', Validators.required],
            incomeFromBusinessRevenue: [false],
            proceedsFromInvestment: [false],
            incomeFromEmployment: [false],
            incomeFromOtherSources: [false],
            incomeFromOtherSourceValue: [''],
            supplier: this.formBuilder.array([this.createSupplier()]),
            customer: this.formBuilder.array([this.createCustomer()]),
            custSuppLoc: this.formBuilder.array([this.createCusSupLoc()]),
            goodsLoc: this.formBuilder.array([this.createCusSupLoc()]),
            isExpectedSupplier: [false],
            isExpectedCustomer: [false],
            taxInfoMalaysia: [false],
            taxInfoUSA: [false],
            taxInfoOthers: [false],
            dealingWithCrimea: ['']
        });

        this.isEditMode = this.activatedRoute.snapshot.paramMap.get('edit') === 'true' ? true : false;
        function disableSelect(elmntId) {
            $(".select-cont#" + elmntId).append("<div class='disabled-select'></div>");
        }

        function enableSelect(elemntId) {
            $("#" + elemntId + " div.disabled-select").remove();
        }
        //test validation start
        //  $(document).change(function () { $("#obaoform").valid();});
        $(document).ready(function () {
            // $(".crimea_section").hide();
            // $(".others-account").hide();
            // $(".others-funding").hide();
            var initialFundingChecked = false;

            $("#others_account").keyup(function () {
                $("#char_count_oa span").text($(this).val().length);
            });


            $("#others_initial_funding").keyup(function () {
                $("#char_count_of span").text($(this).val().length);
            });

            $(".account-mainly-used").click(function () {
                var show_other_account = false;
                $(".account-mainly-used select").each(function () {
                    if ($(this).val() === TransactionConstants.AccountOthersValue) {
                        $(".others-account").show()
                    }
                    else {
                        $(".others-account").hide()
                    }
                })
            })

            $("#account_mainly_used").change(function(){
                if(this.value=="OTH"){
                $(".others-account").css("display","block");
                }else{
                $(".others-account").css("display","none");
                }
                });
                

            $("#initial-funding").click(function () {
                if ($(this).is(":checked")) {
                    $(".others-funding").show();
                    initialFundingChecked = true;
                } else {
                    $(".others-funding").hide();
                    initialFundingChecked = false;

                }
            })

            function validateCustSupLoc() {
                if ($("#no_suppliers_name").prop("checked") && $("#no_customers_name").prop("checked")) {
                    $(".csLoc-disable").prop("disabled", true);
                    $("#add-custSuppLoc").prop("disabled", true);
                } else {
                    $(".csLoc-disable").prop("disabled", false);
                    $("#add-custSuppLoc").prop("disabled", false);
                }
            }

            $("#no_suppliers_name").change(function () {

                if ($("#no_suppliers_name").prop("checked") === true) {
                    $(".supplier_name").prop("disabled", true);
                    $("#add-supplier").prop("disabled", true);
                    $(".supplier_country").prop("disabled", true);
                    // var val = $("#supp select").val();
                    // $("#supp .select-selected").css({ "color": "darkgrey", "background-color": "#eee" });
                    // disableSelect("supp-cont");
                    // $("#supp select").val("");
                    // $("#supp .select-selected").text("Please select");
                    $("#add-supplier").prop("disabled", true);
                    // console.log(val);
                } else {
                    $(".supplier_name").prop("disabled", false);
                    $(".supplier_country").prop("disabled", false);
                    enableSelect("supp-cont");
                    // $("#supp .select-selected").css({ "color": "#000", "background-color": "#fff" });
                    $("#add-supplier").prop("disabled", false);
                }

                validateCustSupLoc();

            });

            $("#no_customers_name").change(function () {

                if ($("#no_customers_name").prop("checked") === true) {
                    $(".customers_name").prop("disabled", true);
                    $("#add-cust").prop("disabled", true);
                    $(".customers_country").prop("disabled", true);
                    // var val = $("#cust select").val();
                    // $("#cust .select-selected").css({ "color": "darkgrey", "background-color": "#eee" });
                    // disableSelect("cust-cont");
                    // $("#cust select").val("");
                    // $("#cust .select-selected").text("Please select");
                    // console.log(val);
                } else {
                    $(".customers_name").prop("disabled", false);
                    $("#add-cust").prop("disabled", false);
                    $(".customers_country").prop("disabled", false);
                    // enableSelect("cust-cont");
                    // $("#cust .select-selected").css({ "color": "#000", "background-color": "#fff" });
                }

                validateCustSupLoc();

            });
            //need fix
            var supplier_field_template = $(".supplier-field").clone();
            var cust_field_template = $(".cust-field:first").clone();
            var count_section_supp = 1;
            var count_section_cust = 1;

            //   $("#add-supplier").click(function () {
            //       if (count_section_supp > 0) {
            //           $("#supp-cb").addClass("hidden");
            //       }

            //       if (count_section_supp < 5) {
            //           count_section_supp++;

            //           // $("#supp-cb").addClass("hidden");
            //         //   var section_supp = supplier_field_template.clone().find(':input').each(function () {
            //         //   }).end().appendTo("#supplier-fields-cont");
            //           // return false;
            //           $(".btn-remove-supp").removeClass("hidden");
            //       }
            //       if (count_section_supp >= 5) {
            //           $(".btn-add-supp").addClass("hidden");
            //       }
            //   });


            //   $("#add-cust").click(function () {
            //       if (count_section_cust > 0) {
            //           $("#cust-cb").addClass("hidden");
            //       }

            //       if (count_section_cust < 5) {
            //           count_section_cust++;

            //           // $("#supp-cb").addClass("hidden");
            //           var section_cust = cust_field_template.clone().find(':input').each(function () {
            //           }).end().appendTo("#cust-fields-cont");
            //           // return false;
            //           $(".btn-remove-cust").removeClass("hidden");
            //       }
            //       if (count_section_cust >= 5) {
            //           $(".btn-add-cust").addClass("hidden");
            //       }
            //   });
            // asdsad
            /*             $("#supplier-fields-cont").on("click", ".btn-remove-supp", function () {
            
                            $(this).parent().fadeOut(300, function () {
                                count_section_supp--;
                                $(this).parent().empty();
            
                            });
            
                            if (count_section_supp !== 4) {
                                $(".btn-add-supp").removeClass("hidden");
                            }
            
                            if (count_section_supp == 2) {
                                // $("#supp-cb").removeClass("hidden");
                                $(".btn-remove-supp").addClass("hidden");
                            }
            
                        });
            
                        $("#cust-fields-cont").on("click", ".btn-remove-cust", function () {
            
                            $(this).parent().fadeOut(300, function () {
                                count_section_cust--;
                                $(this).parent().empty();
                                return false;
                            });
            
                            if (count_section_cust !== 4) {
                                // $(".btn-add-cust").removeClass("hidden");
                            }
                            if (count_section_cust == 2) {
                                // $("#cust-cb").removeClass("hidden");
                                // $(".btn-remove-cust").addClass("hidden");
                            }
                        });
             */

            //DCI update (15/7/2020): Disable keypress enter or other to navigate page
            $("form").bind("keypress", function (e) {
                if (e.keyCode == 13) {
                    return false;
                }
            })
            
          

        });
        this.callDropdownValues().then(this.appComp.loadCustomDropdown);
        const requestId = 'R0050';
        const flowId = JSON.parse(sessionStorage.getItem('ServiceHeader')).Flow;
        this.getResponse(requestId, flowId);
        this.hideOnPageLoad();
        this.setFormValidators(false);
    }
    
    validateChar(field){
        if(!this.AppUtility.stringValidation(field.value.name)){
            field.get('name').setValue(this.AppUtility.filterInvalidCharacters(field.value.name));
        }
    }

    setFormValidators(crimeaDealing){
        // console.log('crimeaDealing: '+ crimeaDealing)
        $("#obaoform").validate({
            rules: {
                account_mainly_used: {
                    required: true
                },
                others_account: {
                    required: false
                    // {
                    //     depends: function (){
                    //         if($("#account_mainly_used").val()== "OTH"){
                    //             return true;
                    //         }else{
                    //             return false;
                    //         }
                    //     }
                    // }
                },
                major_sales_originate: {
                    required: true
                },
                others_initial_funding: {
                    required: false
                    // {
                    //     depends: function (){
                    //         if(initialFundingChecked){
                    //             return true;
                    //         }else{
                    //             return false;
                    //         }
                    //     }
                    // }
                },
                customer_supplier_location: {
                    required: true
                },
                goods_services_location: {
                    required: true
                },
                number_transactions_per_month: {
                    required: true
                },
                total_transaction_per_month: {
                    required: true
                },
                "fund_list[]": {
                    required: true,
                    minlength: 1
                },
                "supplier_name[]": {
                    required: false
                    // Removed CJT 03Jul2020 to be handled by Reactive
                    /* {
                        depends: function (element) {
                            if ('' == $(".supplier_name").val()) {
                                $(".supplier_name").val('');
                            }
                            return true;
                        }
                    } */
                },
                "supplier_country[]": {
                    required: false
                    // Removed CJT 03Jul2020 to be handled by Reactive
                    /* {
                        depends: function (element) {
                            if ('' == $(".supplier_country").val()) {
                                $(".supplier_country").val('');
                            }
                            return true;
                        }
                    } */
                },
                "customers_name[]": {
                    required: false
                    // Removed CJT 03Jul2020 to be handled by Reactive
                    /* {
                        depends: function (element) {
                            if ('' == $(".customers_name").val()) {
                                $(".customers_name").val('');
                            }
                            return true;
                        }
                    } */
                },
                "customers_country[]": {
                    required: false
                    // Removed CJT 03Jul2020 to be handled by Reactive
                    /* {
                        depends: function (element) {
                            if ('' == $(".customers_country").val()) {
                                $(".customers_country").val('');
                            }
                            return true;
                        }
                    } */
                },
                "tax_country[]": {
                    required: true
                },
                // dealingWithCrimea: {
                //     required: false
                // },
            //    dealingWithCrimea: {
            //        required: crimeaDealing
            //    },
                generate_income: {
                    required: true
                }
            },
            // (Begin) CJT 08Jul2020 to display error message when user skipped the field
            onfocusout: function (element) {
                $(element).valid();
            },
            // (End) CJT 08Jul2020
            messages: {

                account_mainly_used: {
                    required: this.langTranslation == 'en-us' || this.langTranslation == undefined ? "Please select an option" : "Sila pilih"
                },
                others_account: {
                    required: this.langTranslation == 'en-us' || this.langTranslation == undefined ? "Please fill in the text area" : "Sila isikan kawasan teks"
                },
                major_sales_originate: {
                    required: this.langTranslation == 'en-us' || this.langTranslation == undefined ? "Please select an option" : "Sila pilih"
                },
                others_initial_funding: {
                    required: this.langTranslation == 'en-us' || this.langTranslation == undefined ? "Please fill in the text area" : "Sila isikan kawasan teks"
                },
                number_transactions_per_month: {
                    required: this.langTranslation == 'en-us' || this.langTranslation == undefined ? "Please select an option" : "Sila pilih"
                },
                total_transaction_per_month: {
                    required: this.langTranslation == 'en-us' || this.langTranslation == undefined ? "Please select an option" : "Sila pilih"
                },
                customer_supplier_location: {
                    required: this.langTranslation == 'en-us' || this.langTranslation == undefined ? "Please select at least one" : "Sila pilih sekurang-kurangnya satu"
                },
                goods_services_location: {
                    required: this.langTranslation == 'en-us' || this.langTranslation == undefined ? "Please select at least one" : "Sila pilih sekurang-kurangnya satu"
                },
                "fund_list[]": {
                    required: "Please select funding sources"
                },
                "supplier_name[]": {
                    required: "Please enter name"
                },
                "supplier_country[]": {
                    required: "Please select country"
                },
                "customers_name[]": {
                    required: "Please enter name"
                },
                "customers_country[]": {
                    required: "Please select country"
                },
                "tax_country[]": {
                    required: "Please select country",
                },
                dealingWithCrimea: {
                    required: "Please select yes or no"
                },
                generate_income: {
                    required: "Please select yes or no"
                }
            },
            errorPlacement: function (error, element) {

                if (element.attr("name") == "customer_supplier_location") {
                    error.appendTo($("#customer_supplier_location_error_container"));
                }
                if (element.attr("name") == "goods_services_location") {
                    error.appendTo($("#goods_services_location_error_container"));
                }

                if (element.attr("name") == "account_mainly_used") {
                    error.appendTo($("#account_mainly_used_error_container"));
                }
                if (element.attr("name") == "others_account") {
                    error.appendTo($("#account_mainly_used_error_container"));
                }

                if (element.attr("name") == "major_sales_originate") {
                    error.appendTo($("#major_sales_originate_error_container"));
                }
                if (element.attr("name") == "number_transactions_per_month") {
                    error.appendTo($("#number_transactions_per_month_error_container"));
                }
                if (element.attr("name") == "total_transaction_per_month") {
                    error.appendTo($("#total_transaction_per_month_error_container"));
                }
                if (element.attr("name") == "fund_list[]") {
                    error.appendTo($("#initial_fund_error_container"));
                }
                if (element.attr("name") == "others_initial_funding") {
                    error.appendTo($("#initial_fund_error_container"));
                }
                if (element.attr("name") == "dealingWithCrimea") {
                    //error.appendTo($("#check_crimea_error_cont"));
                }
                if (element.attr("name") == "supplier_name[]") {
                    error.appendTo($("#supplier_name_error_container"));
                }
                if (element.attr("name") == "supplier_country[]") {
                    error.appendTo($("#supplier_country_error_container"));
                }
                if (element.attr("name") == "customers_name[]") {
                    error.appendTo($("#customers_name_error_container"));
                }
                if (element.attr("name") == "customers_country[]") {
                    error.appendTo($("#customers_country_error_container"));
                }
                if (element.attr("name") == "tax_country[]") {
                    error.appendTo($("#crimea_error_cont"));
                }
                if (element.attr("name") == "generate_income") {
                    error.appendTo($("#income_error_cont"));
                }

            },
            submitHandler: function (form) {
                // $("#btn-next").prop("disabled", true);
            }


        });
    }

    async callDropdownValues() {
        this.refETDL = JSON.parse(sessionStorage.RefETDL);
        this.refNTDL = JSON.parse(sessionStorage.RefNTDL);
        this.refPADL = JSON.parse(sessionStorage.RefPADL);
        this.refCCDL = JSON.parse(sessionStorage.RefCCDL);
        this.refET = JSON.parse(sessionStorage.RefET);
        this.refDWC = JSON.parse(sessionStorage.RefDWC);
        this.refDWC.sort((r1, r2) => (r1.Value > r2.Value) ? -1 : 0);
    }

    public hideOnPageLoad() {
        $(".others-account").hide();
        $(".others-funding").hide();
        $(".btn-remove-cust").addClass("hidden");
        $(".btn-remove-supp").addClass("hidden");
        $(".crimea_section").hide();
    }

    // method to call retrieval api
    public async getResponse(requestId, flowId) {
        const responseData = await this.connectRestService.connectRest(flowId, requestId, '');
        if (responseData.Status === 'Success') {
            this.setFormData(responseData);
        }
    }

    // method to set formdata during pageload
    public setFormData(responseData) {
        const data = responseData.KYCQuestionnaires;

        if (data && data.AccountUsage && data.AccountUsage.Value) {
            this.transactionDetails.controls.accountUsage.setValue(data.AccountUsage.Value);
            if (data.AccountUsage.Value === TransactionConstants.AccountOthersValue) {
                $(".others-account").show();
                this.transactionDetails.controls.accountUsageOthers.setValue(data.AccountUsage.Other);
                this.transactionDetails.get('accountUsageOthers').setValidators([Validators.required]);
                this.transactionDetails.get('accountUsageOthers').updateValueAndValidity();
            }
        }
        const activeIncome = data.ActiveIncome ? 'Yes' : (data.ActiveIncome === false ? 'No' : '')
        this.transactionDetails.controls.activeIncome.setValue(activeIncome);
        if (data.SalesOrigin && data.SalesOrigin.Country != "") {
            this.transactionDetails.controls.salesOrigin.setValue(data.SalesOrigin.Country);
        } else {
            this.transactionDetails.controls.salesOrigin.setValue("MY");
        }


        this.transactionDetails.controls.transactionCount.setValue(data.InflowFund);
        this.transactionDetails.controls.transactionAmount.setValue(data.OutflowFund);
        if (data.SourceOfFund && data.SourceOfFund.length > 0) {
            for (let source of data.SourceOfFund) {
                if (source.Name === TransactionConstants.BusinessInvestment) {
                    this.transactionDetails.controls.incomeFromBusinessRevenue.setValue(source.IsSelected);
                } else if (source.Name === TransactionConstants.IncomeFromEmployment) {
                    this.transactionDetails.controls.incomeFromEmployment.setValue(source.IsSelected);
                } else if (source.Name === TransactionConstants.ProceedsFromBusiness) {
                    this.transactionDetails.controls.proceedsFromInvestment.setValue(source.IsSelected);
                } else if (source.Name === TransactionConstants.IncomeFromOtherSources) {
                    this.transactionDetails.controls.incomeFromOtherSources.setValue(source.IsSelected);
                    if (source.IsSelected) {
                        $(".others-funding").show();
                        this.transactionDetails.controls.incomeFromOtherSourceValue.setValue(source.Other);
                        this.transactionDetails.get('incomeFromOtherSourceValue').setValidators([Validators.required]);
                        this.transactionDetails.get('incomeFromOtherSourceValue').updateValueAndValidity();
                    }
                }
            }
        }
        this.transactionDetails.controls.isExpectedCustomer.setValue(data.NoExpectedCustomer);
        this.transactionDetails.controls.isExpectedSupplier.setValue(data.NoExpectedSupplier);
        this.supplier = this.transactionDetails.get('supplier') as FormArray;
        if (data && data.ExpectedSupplier && data.ExpectedSupplier.length > 0) {
            for (let i = 0; i < data.ExpectedSupplier.length; i++) {
                if (i > 0) {
                    this.addSupplier();
                }
                this.supplier.controls[i].get('name').setValue(data.ExpectedSupplier[i].Name);
                // this.supplier.controls[i].get('country').setValue(data.ExpectedSupplier[i].Country);
                this.supplier.controls[i].get('partyType').setValue(data.ExpectedSupplier[i].PartyType);
            }
            if (data.ExpectedSupplier.length > 1) {
                $(".btn-remove-supp").removeClass("hidden");
            } else {

            }

        }

        // auto population customer supplier location
        this.custSuppLoc = this.transactionDetails.get('custSuppLoc') as FormArray;
            for (let i = 0; i < data.CustomerLocation.length; i++) {
                if (i > 0) {
                    this.addcustSuppLoc();
                }
                this.custSuppLoc.controls[i].get('country').setValue(data.CustomerLocation[i].Country);
            }
        
        // auto population goods location
        this.goodsLoc = this.transactionDetails.get('goodsLoc') as FormArray;
        for (let i = 0; i < data.GoodServicesDestination.length; i++) {
            if (i > 0) {
                this.addgoodsLoc();
            }
            this.goodsLoc.controls[i].get('country').setValue(data.GoodServicesDestination[i].Country);
        }

        
        // auto population customer
        this.customer = this.transactionDetails.get('customer') as FormArray;
        if (data && data.ExpectedCustomer && data.ExpectedCustomer.length > 0) {
            for (let i = 0; i < data.ExpectedCustomer.length; i++) {
                if (i > 0) {
                    this.addCustomer();
                }
                this.customer.controls[i].get('name').setValue(data.ExpectedCustomer[i].Name);
                // this.customer.controls[i].get('country').setValue(data.ExpectedCustomer[i].Country);
                this.customer.controls[i].get('partyType').setValue(data.ExpectedCustomer[i].PartyType);
            }
            if (data.ExpectedCustomer.length > 1) {
                $(".btn-remove-cust").removeClass("hidden");
            } else {

            }
        }
        if (responseData.TaxInfo && responseData.TaxInfo.length > 0) {
            for (let country of responseData.TaxInfo) {
                if (country.TaxCountry === TransactionConstants.TaxInfoMalaysia) {
                    this.transactionDetails.controls.taxInfoMalaysia.setValue(country.IsSelected);
                } else if (country.TaxCountry === TransactionConstants.TaxInfoUSA) {
                    this.transactionDetails.controls.taxInfoUSA.setValue(country.IsSelected);
                } else if (country.TaxCountry === TransactionConstants.TaxInfoOthers) {
                    this.transactionDetails.controls.taxInfoOthers.setValue(country.IsSelected);
                }
            }
        }
        //const dealingWithCrimea = data.Crimea ? 'Yes' : (data.Crimea === false ? 'No' : '')
        
        if (data.DealWithCrimea || data.DealWithCrimeaFlag) {
            $(".crimea_section").show();
            this.transactionDetails.controls.dealingWithCrimea.setValue(data.DealWithCrimea);
            this.transactionDetails.controls["dealingWithCrimea"].setValidators([Validators.required]);
            this.transactionDetails.get('dealingWithCrimea').updateValueAndValidity();
        }
        this.dealWithCrimeaFlag = data.DealWithCrimeaFlag;

        if (data.NoExpectedCustomer) {
            $(".customers_name").prop("disabled", true);
            $("#add-cust").prop("disabled", true);
            $(".customers_country").prop("disabled", true);
            this.removeCustomerValidations();
        }
        if (data.NoExpectedSupplier) {
            $(".supplier_name").prop("disabled", true);
            $("#add-supplier").prop("disabled", true);
            $(".supplier_country").prop("disabled", true);
            this.removeSupplierValidations();
        }
        if (data.NoExpectedCustomer && data.NoExpectedSupplier) {
            $(".csLoc-disable").prop("disabled", true);
            $("#add-custSuppLoc").prop("disabled", true);
            this.removeCustSupLocrValidations();
        }
        // (Begin) Added by CJT 08Jul2020 to put flag on Crimea Check
        // this.validateCrimea("supplier", true);
        // this.validateCrimea("customer", true);

        if(data.Crimea == true){
            $('#rbYesCrimea').prop("checked", true);
            this.crimeaError = false;
        }else if(data.Crimea == false){
            $('#rbNoCrimea').prop("checked", true);
            this.crimeaError = false;
        }
        // (End) CJT 08Jul2020
    }

    public createSupplier(): FormGroup {
        return this.formBuilder.group({
            name: ['', Validators.required],
            // country: ['', Validators.required],
            partyType: ['', Validators.required]
        });
    }

    public createCusSupLoc(): FormGroup {
        return this.formBuilder.group({
            country: ['', Validators.required],
        });
    }

    public addSupplier() {
        $(".btn-remove-supp").removeClass("hidden");
        this.supplier = this.transactionDetails.get('supplier') as FormArray;
        this.supplier.push(this.createSupplier());
        if (this.supplier.length > 1) {
            $("#supp-cb").addClass("hidden");
        }
        if (this.supplier.length >= 5) {
            $(".btn-add-supp").addClass("hidden");
        }
    }
    public removeSupplier(index) {
        if (this.supplier.length === 1) {
            this.supplier.controls[0].patchValue({
                name: '',
                // country: ''
            })
        } else {
            this.supplier.removeAt(index);

        }
        if (this.supplier.length < 5) {
            $(".btn-add-supp").removeClass("hidden");
        }
        if (this.supplier.length === 1) {
            $("#supp-cb").removeClass("hidden");
        }
        // this.validateCrimea('supplier');
        // this.crimeaError = false;
    }

    public createCustomer(): FormGroup {
        return this.formBuilder.group({
            name: ['', Validators.required],
            // country: ['', Validators.required],
            partyType: ['', Validators.required]
        });
    }

    public addCustomer() {
        $(".btn-remove-cust").removeClass("hidden");
        this.customer = this.transactionDetails.get('customer') as FormArray;
        this.customer.push(this.createCustomer());
        if (this.customer.length > 1) {
            $("#cust-cb").addClass("hidden");
        }
        if (this.customer.length >= 5) {
            $(".btn-add-cust").addClass("hidden");
        }
    }

    public removeCustomer(index) {
        if (this.customer.length === 1) {
            this.customer.controls[0].patchValue({
                name: '',
                // country: ''
            })
        } else {
            this.customer.removeAt(index);
        }

        if (this.customer.length < 5) {
            $(".btn-add-cust").removeClass("hidden");
        }
        if (this.customer.length === 1) {
            $("#cust-cb").removeClass("hidden");
        }
        // this.validateCrimea('customer');
        // this.crimeaError = false;
    }
  //start
    public addcustSuppLoc() {
      //  $("#csLoc .custSuppLoc").clone().find('.csLoc-country').val('').end().appendTo('#add_custSuppLoc');
        this.addcustSuppLocBtn = this.addcustSuppLocBtn + 1
        this.custSuppLoc = this.transactionDetails.get('custSuppLoc') as FormArray;
        this.custSuppLoc.push(this.createCusSupLoc());
        if (this.custSuppLoc.length > 1) {
            // $("#cust-cb").addClass("hidden");
        }
    }

    public removeCustSuppLoc(index) {
        if (this.custSuppLoc.length === 1) {
            this.custSuppLoc.controls[0].patchValue({
                country: ''
            })
        } else {
            this.custSuppLoc.removeAt(index);
        }
        this.addcustSuppLocBtn = this.addcustSuppLocBtn - 1
        this.validateCrimea('customer');
    }

  // end

    //start
    public addgoodsLoc() {
        this.addgoodsLocBtn = this.addgoodsLocBtn + 1
        this.goodsLoc = this.transactionDetails.get('goodsLoc') as FormArray;
        this.goodsLoc.push(this.createCusSupLoc());
        if (this.goodsLoc.length > 1) {
            //$("#cust-cb").addClass("hidden");
        }
    }
  
    public removegoodsLoc(index) {
        if (this.goodsLoc.length === 1) {
            this.goodsLoc.controls[0].patchValue({
                country: ''
            })
        } else {
            this.goodsLoc.removeAt(index);
        }
        this.addgoodsLocBtn = this.addgoodsLocBtn - 1;
        this.validateCrimea('customer');
      }
  
    // end

    public accountUsageChange(event) {
        if (event.target.value !== TransactionConstants.AccountOthersValue) {
            this.transactionDetails.controls.accountUsageOthers.setValue('');
            this.transactionDetails.get('accountUsageOthers').clearValidators();
        } else {
            this.transactionDetails.get('accountUsageOthers').setValidators([Validators.required]);
        }
        this.transactionDetails.get('accountUsageOthers').updateValueAndValidity();

    }

    public incomeFromOtherSources(event) {
        if (!event.target.checked) {
            this.transactionDetails.controls.incomeFromOtherSourceValue.setValue('');
            this.transactionDetails.get('incomeFromOtherSourceValue').clearValidators();
        } else {
            this.transactionDetails.get('incomeFromOtherSourceValue').setValidators([Validators.required]);
        }
        this.transactionDetails.get('incomeFromOtherSourceValue').updateValueAndValidity();
    }

    clearFormArray = (formArray: FormArray) => {
        while (formArray.length !== 1) {
            formArray.removeAt(0);
        }
    }

    public isExpectedSupplierChange(event) {
        if (event.target.checked) {
            this.supplier = this.transactionDetails.get('supplier') as FormArray;
            this.clearFormArray(this.supplier);
            this.supplier.controls[0].patchValue({
                name: '',
                partyType: ''
            })
            this.removeSupplierValidations();
            
        } else {
            this.supplier.controls[0].get('name').setValidators([Validators.required]);
            this.supplier.controls[0].get('name').updateValueAndValidity();
            // this.supplier.controls[0].get('country').setValidators([Validators.required]);
            // this.supplier.controls[0].get('country').updateValueAndValidity();
            this.supplier.controls[0].get('partyType').setValidators([Validators.required]);
            this.supplier.controls[0].get('partyType').updateValueAndValidity();
        }

        if (this.customer.length < 5) {
            $(".btn-add-supp").removeClass("hidden");
        }
        setTimeout(() => {
            this.validateCrimea('supplier', false);
        }, 300);
        this.validateCustSupLoc();
    }

    public removeSupplierValidations() {
        this.supplier.controls[0].get('name').clearValidators();
        this.supplier.controls[0].get('name').updateValueAndValidity();
        // this.supplier.controls[0].get('country').clearValidators();
        // this.supplier.controls[0].get('country').updateValueAndValidity();
        this.supplier.controls[0].get('partyType').clearValidators();
        this.supplier.controls[0].get('partyType').updateValueAndValidity();
    }


    public isExpectedCustomerChange(event) {
        if (event.target.checked) {
            this.customer = this.transactionDetails.get('customer') as FormArray;
            this.clearFormArray(this.customer);
            this.customer.controls[0].patchValue({
                name: '',
                partyType: ''
            });
            this.removeCustomerValidations();
        } else {
            

            this.customer.controls[0].get('name').setValidators([Validators.required]);
            this.customer.controls[0].get('name').updateValueAndValidity();
            // this.customer.controls[0].get('country').setValidators([Validators.required]);
            // this.customer.controls[0].get('country').updateValueAndValidity();
            this.customer.controls[0].get('partyType').setValidators([Validators.required]);
            this.customer.controls[0].get('partyType').updateValueAndValidity();
        }

        if (this.customer.length < 5) {
            $(".btn-add-cust").removeClass("hidden");
        }
        setTimeout(() => {
            this.validateCrimea('customer', false);
        }, 300);
        this.validateCustSupLoc();
    }

    public removeCustomerValidations() {
        this.customer.controls[0].get('name').clearValidators();
        this.customer.controls[0].get('name').updateValueAndValidity();
        // this.customer.controls[0].get('country').clearValidators();
        // this.customer.controls[0].get('country').updateValueAndValidity();
        this.customer.controls[0].get('partyType').clearValidators();
        this.customer.controls[0].get('partyType').updateValueAndValidity();
    }

    validateCustSupLoc() {
        this.custSuppLoc = this.transactionDetails.get('custSuppLoc') as FormArray;
        if ($("#no_suppliers_name").prop("checked") && $("#no_customers_name").prop("checked")) {
            this.clearFormArray(this.custSuppLoc);
            this.custSuppLoc.controls[0].patchValue({
                country: ''
            });
            this.removeCustSupLocrValidations();
        } else {
            this.custSuppLoc.controls[0].get('country').setValidators([Validators.required]);
            this.custSuppLoc.controls[0].get('country').updateValueAndValidity();
        }
    }

    removeCustSupLocrValidations() {
        this.custSuppLoc.controls[0].get('country').clearValidators();
        this.custSuppLoc.controls[0].get('country').updateValueAndValidity();
    }
    //(Begin) Added by CJT 25Jun2020 for Validating UKRAINE and RUSSIA from selected country in Supplier and Country sections
    
    validateCrimea(dltype, onInit?: boolean) {
        var tempCrimeaValue = "";
        if (this.dealWithCrimeaFlag) {
            return;
        }

        if (onInit) {
            tempCrimeaValue = this.transactionDetails.value.dealingWithCrimea;
        }
        
        for (let i = 0; i < this.custSuppLoc.controls.length; i++) {
            if (this.custSuppLoc.controls[i].value.country === 'RU' || this.custSuppLoc.controls[i].value.country === 'UA') {
                this.hasCrimea = true;
                break;
            } else {
                this.hasCrimea = false;
            }
        }

        if (!this.hasCrimea) {
            for (let i = 0; i < this.goodsLoc.controls.length; i++) {
                if (this.goodsLoc.controls[i].value.country === 'RU' || this.goodsLoc.controls[i].value.country === 'UA') {
                    this.hasCrimea = true;
                    break;
                } else {
                    this.hasCrimea = false;
                }
            }
        }

        if (this.hasCrimea) {
            $(".crimea_section").show();
            this.check_crimea = true;
            $('#obaoform').validate()
            $('input[name="dealingWithCrimea"]').rules('add','required')
            // this.transactionDetails.controls["dealingWithCrimea"].setValue(null);
            this.transactionDetails.controls["dealingWithCrimea"].setValidators([Validators.required]);
            this.transactionDetails.get('dealingWithCrimea').updateValueAndValidity();
            // console.log(this.transactionDetails.value)
        } else {
            $(".crimea_section").hide();
            $('#obaoform').validate()
            $('input[name="dealingWithCrimea"]').rules('remove','required')
            this.check_crimea = false;
            this.transactionDetails.controls["dealingWithCrimea"].clearValidators();
            this.transactionDetails.controls["dealingWithCrimea"].setValue("");
            this.transactionDetails.get('dealingWithCrimea').updateValueAndValidity();
            // console.log('FALSE')
        }
        
    }

    public isFormValid() {

        // change condition for new fields
        // if (!this.transactionDetails.value.incomeFromBusinessRevenue && !this.transactionDetails.value.incomeFromEmployment &&
        //     !this.transactionDetails.value.proceedsFromInvestment && !this.transactionDetails.value.incomeFromOtherSources) {
        //     return false;
        // }
        // if (!this.transactionDetails.value.taxInfoMalaysia && !this.transactionDetails.value.taxInfoUSA &&
        //     !this.transactionDetails.value.taxInfoOthers) {
        //     return false;
        // }
        // return this.transactionDetails.valid;
        
        return true;
    }


    onSubmit() {
        // if (!($(".crimea_section").is(':visible'))) {
        //     this.transactionDetails.controls.dealingWithCrimea.setValue(null);
        // }
        // if(this.check_crimea && $('input[name="dealingWithCrimea"]:checked').val() == undefined){
        //     this.crimeaError = true;
        //     return false;
        // }
        if ($("#obaoform").valid()) {
            let serviceBody = {
                "KYCQuestionnaires": {
                    "AccountUsage": {
                        "Value": this.transactionDetails.value.accountUsage,
                        "Other": this.transactionDetails.value.accountUsageOthers
                    },                    
                    "InflowFund": this.transactionDetails.value.transactionCount,
                    "OutflowFund": this.transactionDetails.value.transactionAmount,
                    "NoExpectedSupplier": this.transactionDetails.value.isExpectedSupplier,
                    "ExpectedSupplier": [],
                    "NoExpectedCustomer": this.transactionDetails.value.isExpectedCustomer,
                    "ExpectedCustomer": [],
                    "NoCustomerLocation": this.transactionDetails.value.isCustomerLocation,
                    "CustomerLocation": [],
                    "NoGoodServicesDestination": this.transactionDetails.value.isGoodServicesDestination,
                    "GoodServicesDestination": [],
                    "DealWithCrimea": this.transactionDetails.value.dealingWithCrimea 
                    // === 'Yes' ? true :
                    //     this.transactionDetails.value.dealingWithCrimea === 'No' ? false : '',
                    // "dealingWithCrimea": this.transactionDetails.value.dealingWithCrimea === 'Yes' ? true : false,    
                   // "ActiveIncome": this.transactionDetails.value.activeIncome === 'Yes' ? true : false,
                },                

            };
            if (!this.transactionDetails.value.isExpectedSupplier) {
                for (let supplier of this.transactionDetails.value.supplier) {
                    serviceBody.KYCQuestionnaires.ExpectedSupplier.push({
                        "Name": supplier.name,
                        // "Country": supplier.country,
                        "PartyType": supplier.partyType
                    })
                }
            }
            if (!this.transactionDetails.value.isExpectedCustomer) {
                for (let customer of this.transactionDetails.value.customer) {
                    serviceBody.KYCQuestionnaires.ExpectedCustomer.push({
                        "Name": customer.name,
                        // "Country": customer.country,
                        "PartyType": customer.partyType
                    })
                }
                
            }
            for (let custSuppLoc of this.transactionDetails.value.custSuppLoc) {
                if (custSuppLoc.country && custSuppLoc.country !== '')
                serviceBody.KYCQuestionnaires.CustomerLocation.push({
                    "Country": custSuppLoc.country,
                    "value":''
                })
            }
            for (let goodsLoc of this.transactionDetails.value.goodsLoc) {
                serviceBody.KYCQuestionnaires.GoodServicesDestination.push({
                    "Country": goodsLoc.country,
                    "value":''
                })
            }

            this.restConnect(serviceBody);
        }

        if (this.hasCrimea){

            if (this.transactionDetails.value.dealingWithCrimea == ""){
            this.crimeaError = true;
            // this.transactionDetails.removeControl(this.transactionDetails.value.dealingWithCrimea);
            } else {
                this.crimeaError = false;
            }
        } else {
            this.crimeaError = false
        }
            // console.log(this.transactionDetails.value.dealingWithCrimea)
    }

    // method for update api
    public async restConnect(data) {
        //   // console.log('-reqe' + JSON.stringify(data))
        const RequestID = 'S0050';
        const responseData = await this.connectRestService.connectRest(data, RequestID, '')
        if (responseData.Status === 'Success') {
            if (!this.isEditMode) {
                this.router.navigate(['/business-banking']);
            } else {
                this.router.navigate(['/director-confirm']);
            }
        }
    }

    onClickCrimea(){
        this.crimeaError = false;
    }

    checkSelectedCountryCS(country, i) {
        let disable = false;
        this.transactionDetails.value.custSuppLoc.forEach((custSuppLoc, index) => {
            if (country === custSuppLoc.country && index !== i) {
                disable = true;
                return disable;
            }
        });

        return disable;
    }

    checkSelectedCountryGS(country, i) {
        let disable = false;
        this.transactionDetails.value.goodsLoc.forEach((goodsLoc, index) => {
            if (country === goodsLoc.country && index !== i) {
                disable = true;
                return;
            }
        }); 
       
        return disable;
    }
}
